<template>
  <div class="list genres-list-page">
    <portal to="search">
      <search placeholder="Find a genre..." v-model="globalFilter"></search>
    </portal>
    <div class="space-between mb-50">
      <h2 class="title primary-color">GENRE LIST</h2>
      <router-link :to="{ name: 'genre-save' }" tag="span">
        <el-button type="primary" class="plain-primary" plain>
          <i class="el-icon-plus"></i>
          CREATE A NEW GENRE
        </el-button>
      </router-link>
    </div>
    <el-table :data="genres.data" v-loading="getGenresLoading">
      <el-table-column prop="id" label="#" width="75"> </el-table-column>
      <el-table-column width="40">
        <template v-slot="scope">
          <i
            class="el-icon-s-cooperation"
            v-if="scope.row.parent_id === null"
          />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="Name of genre" min-width="250">
      </el-table-column>
      <el-table-column
        prop="color"
        label="Color"
        min-width="50"
        class-name="color-column"
      >
        <template v-slot="scope">
          <div class="el-color-picker static-color-picker">
            <div class="el-color-picker__trigger">
              <span class="el-color-picker__color">
                <span
                  class="el-color-picker__color-inner"
                  :style="{ 'background-color': scope.row.color || '#0091ea' }"
                ></span>
              </span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Actions" width="220">
        <template v-slot="scope">
          <router-link
            :to="{ name: 'genre-save', params: { id: scope.row.id } }"
            tag="span"
            class="ml-10"
          >
            <el-button type="primary" size="small" class="plain-primary" plain>
              <i class="el-icon-edit" />
            </el-button>
          </router-link>
          <el-popconfirm
            confirmButtonText="OK"
            cancelButtonText="No, Thanks"
            icon="el-icon-info"
            iconColor="red"
            title="Are you sure to delete this?"
            @confirm="confirmDelete(scope.row.id)"
            @cancel="
              $notify({
                title: 'Cancel',
                message: 'Deletion cancelled',
                type: 'info',
              })
            "
          >
            <el-button
              size="small"
              type="danger"
              slot="reference"
              class="ml-10"
            >
              <i class="el-icon-delete" />
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <paginator
      :meta="genres.meta"
      :current-page.sync="currentPage"
      :per-page.sync="perPage"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Paginator from '@/components/Form/Paginator'
import { pagination } from '@/mixins'
import Search from '@/components/Form/Search.vue'

export default {
  components: {
    Paginator,
    Search,
  },
  mixins: [pagination('getGenres')],
  computed: {
    ...mapState('genre', ['genres', 'getGenresLoading']),
  },
  mounted() {
    this.getGenres()
  },
  methods: {
    ...mapActions('genre', ['getGenres', 'deleteGenre']),
    async confirmDelete(id) {
      try {
        await this.deleteGenre({
          routeParameters: {
            id,
          },
        })
        this.search(true)
        this.$notify({
          title: 'Success',
          message: 'Deletion succeed',
          type: 'success',
        })
      } catch (e) {
        this.$notify({
          title: 'Failed',
          message: 'Deletion Failed',
          type: 'danger',
        })
      }
    },
  },
}
</script>
